enum FIELD_RENDER_TYPES {
    AVATAR = 'avatar',
    SELECT = 'select',
    SELECT_SOUND = 'select-sound',
    INPUT_WITH_ACTION = 'input_with_action',
    INPUT = 'input',
    INPUT_INTEGER = 'input-integer',
    INPUT_PASSWORD = 'input-password',
    PASSWORD_GROUP = 'password-group',
    TEXTAREA = 'textarea',
    FILE = 'file',
    FILE_UPLOAD = 'file-upload',
    VIDEO_UPLOAD = 'video-upload',
    MULTI_FILES = 'multi-files',
    CHECKBOX = 'checkbox',
    CHECKBOX_LIST_OPTION = 'checkbox-list-option',
    TUMBLER = 'tumbler',
    CHECKBOXES = 'checkboxes',
    MULTI_SELECT = 'multi-select',
    MULTI_SELECT_CHECKBOXES = 'multi-select-checkboxes',
    MULTI_SELECT_WITH_LABELS_BELOW = 'multi-select-with-labels-below',
    QUICK_BUTTON = 'quick-button',
    COMPOUND = 'compound',
    ARRAY = 'array',
    ARRAY_WITH_PROTOTYPE = 'array-with-prototype',
    ARRAY_ORDER_SENSITIVE = 'array-order-sensitive',
    COLLECTION = 'collection',
    FORM = 'form',
    SECTIONAL_FORM = 'sectional-form',
    TABBED_FORM = 'tabbed-form',
    AUDIO = 'audio',
    RADIO = 'radio',
    RADIO_TREE = 'radio-tree',
    RADIO_CHOICE = 'radio-choice',
    RADIO_CHOICE_INLINE = 'radio-choice-inline',
    CHECKBOX_TREE = 'checkbox-tree',
    EVALUATION_DESCRIPTION = 'eval-description',
    EVALUATION_IMAGE = 'eval-image',
    EVALUATION_STATIC_TEXT = 'eval-static-text',
    EVALUATION_MULTIPOINT = 'evaluation-multipoint',
    RETENTION_RULE = 'retention-rule',
    GRID_SIZE = 'grid-size',
    DATE_TYPE = 'date-type',
    REPORT_DATE = 'report-date',
    CALENDAR = 'calendar',
    FILTER_INFO_ITEMS_CONTAINER = 'filter-info-items-container',
    EVALUATION_COLLAPSE = 'evaluation-collapse',
    FILTER = 'filter',
    SEARCH = 'search',
    COMMENT_REVIEW = 'comment-review',
    RADIO_CHECKBOX_TREE = 'radio-checkbox-tree',
    EXPIRATION = 'expiration',
    UPLOAD_LINK_EXPIRATION = 'upload-link-expiration',
    PIN_CODE = 'pin-code',
    UPLOAD_PASSCODE = 'upload-passcode',
    COLOR_PICKER = 'color-picker',
    ASYNC_TYPEAHEAD = 'async-typeahead',
    ZOOM_ACCOUNT = 'zoom-account',
    SINGLE_CHOICE = 'single_choice',
    AUTHOR_CHOICE = 'author_choice',
    MULTIPLE_CHOICE = 'multiple_choice',
    RIGHTS_CHOICE = 'rights_choice',
    USERS_GROUPS_CHOICE = 'users_groups_choice',
    SCHEDULE_RULES = 'schedule_rules',
    DATE_FILTER = 'date_filter',
    PRESETS_CONTROL = 'presets_control',
    TEMPLATE_SELECTION_COLLECTION = 'template_selection_collection',
    DATE_RANGE = 'date-range',
    DIRECT_DATE_RANGE = 'direct-date-range',
    DIRECT_DATE_TIME_RANGE = 'direct-date-time-range',
    DURATION = 'duration',
    NONE = 'none',
    RESTRICT_ACCESS = 'restrict_access',
    STATIC_TEXT = 'static_text',
    STATIC_IMAGE = 'static_image',
    MOTION_DETECTION_MASK = 'motion-detection-mask',
    OCR_CONFIG = 'ocr-config',
    CAMERA_MAC_ADDRESS = 'camera-mac-address',
    CAMERA_PTZ_RESET = 'camera-ptz-reset',
    SELECT_HELP_ICON = 'select-help-icon',
    DEVICES_MOTION_DETECTION = 'devices-motion-detection',
}

export const uploadTypes: FIELD_RENDER_TYPES[] = [
    FIELD_RENDER_TYPES.FILE_UPLOAD,
    FIELD_RENDER_TYPES.VIDEO_UPLOAD,
];

export default FIELD_RENDER_TYPES;
